import * as Yup from "yup";

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email("The email address format you have entered is invalid")
    .required("Email address is required"),
});
